export const LOGIN_SIGNUP_CLICK =  "hp_login_signup_click";
export const LOGIN_INITIATED =  "hp_login_initiated";
export const LOGIN_OTP_VERIFIED =  "hp_login_otp_verified";
export const LOGIN_PASSWORD_VERIFIED =  "hp_login_password_verified";
export const SIGNUP_INITIATED = "hp_signup_initiated";
export const LOCATION_REQUEST = "hp_location_request";
export const LOCATION_CONFIRM = "hp_location_confirm";
export const CART_PAGE_LOAD = "hp_cart_page";
export const CHECKOUT_PAGE_LOAD = "hp_checkout_page";
export const CHECKOUT_INITIATED = "hp_checkout_initiated";
export const CHECKOUT_ERROR = "hp_checkout_error";
export const ORDER_PLACED = "hp_order_placed";
export const ADD_TO_CART = "hp_add_to_cart";
export const SEARCH_KEYWORD = "hp_search_keyword" 


// sub actions
export const LOCATION_REQUEST_MANUAL = "manual";
export const LOCATION_REQUEST_GPS = "gps";
export const ADD_TO_CART_PRODUCT_ID = "product_id";
export const SEARCH_KEYWORD_QUERY = "query"; 